import { Link } from "react-router-dom";
import { PDPA_INTRO, PDPA_PURPOSES, PDPA_WITHDRAW } from "@/data/content";

// Mandatory PDPA consent wording (Infinity FA Advertising & Marketing Guidelines, Appendix 7). Render immediately before every lead-form submit button.
export const PdpaNotice = ({ dark = false, testId = "pdpa-notice" }) => (
  <span className={`block text-[13px] leading-relaxed ${dark ? "text-[rgba(244,241,234,.55)]" : "text-[var(--muted)]"}`} data-testid={testId}>
    {PDPA_INTRO}
    <ul className="my-1 pl-4 list-disc marker:text-[var(--gold)] space-y-0.5">
      {PDPA_PURPOSES.map((p) => <li key={p}>{p}</li>)}
    </ul>
    {PDPA_WITHDRAW} See our <Link to="/privacy-policy" className="underline underline-offset-2 hover:text-[#9a7225]">privacy policy</Link>.
  </span>
);
